import { EAccessType, TBooleanRecord } from "types";

export const getAccessRightByAccessType = ({
  corporationAccessRight,
  buAccessRight,
  communityAccessRight,
  accessType,
}: {
  corporationAccessRight?: TBooleanRecord;
  buAccessRight?: TBooleanRecord;
  communityAccessRight?: TBooleanRecord;
  accessType?: EAccessType;
}) => {
  let accessRight: TBooleanRecord = {};
  switch (accessType) {
    case EAccessType.CORP:
      accessRight = { ...corporationAccessRight };
      break;
    case EAccessType.BU:
      accessRight = { ...buAccessRight };
      break;
    case EAccessType.COM:
      accessRight = { ...communityAccessRight };
      break;
    default:
      accessRight = {};
      break;
  }
  return accessRight;
};
